export default __webpack_public_path__ + "static/media/Thumb_Facial_Hair_01.f22f481a.png";